import React from 'react'
import { Container, Row, Col, Button, Image, Navbar, Nav, Card } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import './LandingPage.css'
import { useHistory } from 'react-router-dom'
import { RiFileAddFill, RiHeartAddFill, RiBarcodeFill } from 'react-icons/ri';

export default function LandingPage() {

    const history = useHistory()


    function showSignup() {
        history.push("/signup")
    }

    return (

        <Container fluid>

            <Row id="landing-div">
                <Navbar bg="dark" variant="dark" expand="lg">
                    <Image style={{ maxWidth: "80px", height: "auto" }} src="/proion-logo.png" />
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <LinkContainer to="/signup"><Nav.Link className="lnk-color-btn fw-bold">Try for Free</Nav.Link></LinkContainer>
                            <LinkContainer to="/login"><Nav.Link className="lnk-color fw-bold">Log In</Nav.Link></LinkContainer>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Row>

            <Row id="landing-heading">
                <Col md={6}>
                    <div className="main">
                        <div className="heading">
                            <h1>Proion <span style={{ color: "rgb(255, 98, 0)" }}>-</span> How companies deal with barcodes</h1>
                            <p style={{ color: "rgb(255, 98, 0)" }}>[ προϊόν / greek ]</p>
                            <p>Simple 3 step tool to help you link product barcode to your company's custom code.</p>
                        </div>
                        <div className="signup">
                            <Button onClick={showSignup} className="btn" size="lg" variant="dark">Start for <span className="free-span">FREE</span></Button>
                        </div>
                    </div>
                </Col>


                <Col md={6}>
                    <div className="img-div">
                        <Image className="img" src="/info-proion.png" fluid />
                    </div>
                </Col>

            </Row>

            <Row className="description-div">
                <Col md={6} className="description">
                    <div className="description3">
                        <h1><span>Proion</span> can save your time and optimize your business</h1>
                        <h3>So easy <span>anyone</span> can use it</h3>
                        <h5>Tech knowledge is <span>not needed</span></h5>
                    </div>
                    <div><Image style={{ with: "100%", height: "150px" }} src="/arrow.png" fluid /></div>
                    <Button onClick={showSignup} className="btn-try" size="lg" variant="dark">It's Easy, Try it here !</Button>
                </Col>
                <Col md={6} className="description2">
                    <h2>Frequent questions</h2>
                    <p className="text"><span>Is Proion easy to use?</span> - It is very easy to use, you don't
                        have to have any tech knowledge. Sign up and you are ready to go!</p>
                    <p className="text"><span>Is Proion free?</span> - Yes, Proion is completely FREE. No credit card needed!</p>
                    <p className="text"><span>How Proion works?</span>
                        <ul>
                            <li>Sign up</li>
                            <li>Go to 'Products' and add your products, barcodes and matching custom codes</li>
                            <li>You can always edit or delete your products</li>
                            <li>Once you have your own data added, you can use 'Search code' page to search products by their barcodes.</li>
                            <li>Enter your barcode on 'Search code' page. It will show your product and custom code.</li>
                            <li>You can always put the output in favorites.</li>
                        </ul>
                    </p>
                </Col>
            </Row>


            <Row className="definition g-4">
                <Row>
                    <Col className="definition-title">
                        <h1>3 easy steps</h1>
                        <p>that will save your time in the long run</p>
                    </Col>
                </Row>
                <Col md={4}>
                    <RiFileAddFill className="steps-icon" />
                    <Card>
                        <Card.Body>
                            <Card.Title className="card-title"> Add product </Card.Title>
                            <Card.Text>
                                Add product to give info about name, barcode and your custom
                                code given to that product.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <RiBarcodeFill className="steps-icon" />
                    <Card>
                        <Card.Body>
                            <Card.Title className="card-title"> Search by barcode </Card.Title>
                            <Card.Text>
                                Search product by barcode, and the app will give you the output
                                with name and your custom code.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <RiHeartAddFill className="steps-icon" />
                    <Card >
                        <Card.Body>
                            <Card.Title className="card-title"> Add to favorites </Card.Title>
                            <Card.Text>
                                Add every search to your list of favorites and do with it
                                whatever needs to be done.
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col className="footer-logo">
                    <Image style={{ maxWidth: "50px", height: "auto" }} src="/proion-logo.png" />
                </Col>
            </Row>

            <Row>
                <Col className="footer-year">
                    <p className="float-end">Proion 2021.</p>
                </Col>
            </Row>
        </Container >

    )
}
